import mitt from 'mitt';
import defaultSlotList from '@/components/page-model/slotList';
import {
  create_order_record,
  get_project_by_id,
  create_order_used_record,
  delete_order_record,
  get_customer_wallet_fl_rate,
  create_order_used_record_by_order,
  send_receipt,
  query_person_to_costom_list,
  direct_delete_set_record,
  direct_delete_order_record,
} from '@/api/mjstore-model';
import { createVNode, reactive } from 'vue';
import { message, Modal, notification } from 'ant-design-vue';
import modalBox from '@/components/form-modal/modal-tools';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import { calculate_cz_price, calculate_fl_price } from '@/components/utils/tools';
import moment from 'moment';
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
import Fail from "@/views/result/fail.vue";

export const event_obj = mitt();
export const btn_list = [
  {
    name: '耗单',
    clazz: 'primary',
    cb: (data: any) => {
      const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
      const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店
      const editModal = reactive({
        loading: false,
        visible: true,
        title: '耗单',
        form: {
          settings: {
            labelAlign: 'right',
            layout: 'horizontal',
            col: [5, 5],
          },
          fields: [
            {
              type: 'input',
              name: 'customer__name',
              label: '会员名称',
              disabled: true,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
            {
              type: 'input',
              name: 'project__name',
              label: '项目名称',
              disabled: true,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
            {
              type: 'input',
              name: 'total_num',
              label: '项目次数',
              disabled: true,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              placeholder: '请填写项目次数',
            },
            // {
            //   type: 'input',
            //   name: 'now_num',
            //   label: '剩余次数',
            //   disabled: true,
            //   allowClear: true,
            //   inputType: 'number',
            //   defaultValue: '',
            //   placeholder: '请填写项目次数',
            // },
            {
              type: 'input',
              name: 'project_price',
              label: '项目单价',
              disabled: true,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
            },
            {
              type: 'input',
              name: 'cxzc__name',
              label: '促销政策',
              disabled: true,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
            {
              type: 'number',
              name: 'num',
              label: '消耗次数',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              min: 1,
              defaultValue: '',
            },

            {
              type: 'datepicker',
              name: 'date',
              label: '耗单日期',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              format: 'YYYY-MM-DD HH:mm',
              valueFormat: 'YYYY-MM-DD HH:mm',
              showTime: true,
              placeholder: '请填写耗单日期',
            },
            {
              type: 'remoteselect',
              name: 'shop_id',
              label: '门店列表',
              disabled: !!current_shop,
              placeholder: '请选择门店列表',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-shop',
            },
            {
              type: 'remoteselect',
              name: 'staff_id',
              label: '执行人',
              disabled: false,
              placeholder: '请选择执行人',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-querystaffselectlist',
            },
            {
              type: 'textarea',
              name: 'mark',
              label: '备注',
              disabled: false,
              allowClear: true,
              inputType: 'text',
              maxlength: 300,
              defaultValue: '',
              placeholder: '请填写备注',
            },
          ],
          rules: {
            num: [{ required: true, message: '请填写消耗次数' }],
            shop_id: [{ required: true, message: '请选门店列表' }],
            staff_id: [{ required: true, message: '请填写执行人' }],
            date: [{ required: true, message: '请填写耗单日期' }],
          },
          model: {
            org_id: current_org?.id,
            is_active: true,
            mark: null,
            cxzc__name: data.cxzc__name,
            order_record_id: data.id,
            staff_id: null,
            date: null,
            shop_id: current_shop?.id,
            num: data.now_num,
            project_price: data.project_price,
            now_num: data.now_num,
            total_num: data.total_num,
            project__name: data.project__name,
            customer__name: data.customer__name,
          },
          watch: {},
        },
        options: {},
        ok: (data: any) => {
          if (Number(data.num) > Number(data.now_num)) {
            notification.error({
              message: '输入错误',
              description: '【耗单次数】 > 【项目余次】',
            });
            return false;
          }
          return new Promise(resolve => {
            editModal.loading = true;
            create_order_used_record({
              ...data,
              org_id: current_org?.id,
            })
              .then(function () {
                message.success('耗单成功');
                event_obj.emit('refresh');
                resolve(null);
              })
              .finally(() => {
                editModal.loading = false;
              });
          });
        },
      });
      modalBox(editModal);
    },
  },
  {
    name: '撤单',
    clazz: 'danger',
    cb: (data: any) => {
      const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
      const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店
      Modal.confirm({
        title: '撤单仅用于客户退项目，若由于门店操作错误而需撤回订单，请点击作废。',
        icon: createVNode(ExclamationCircleOutlined),
        onOk() {
          return new Promise(resolve1 => {
            const editModal = reactive({
              visible: true,
              loading: false,
              title: '撤单',
              form: {
                settings: {
                  labelAlign: 'right',
                  layout: 'horizontal',
                  col: [5, 5],
                },
                fields: [
                  {
                    type: 'input',
                    name: 'customer__name',
                    label: '会员名称',
                    disabled: true,
                    allowClear: true,
                    inputType: 'text',
                    defaultValue: '',
                  },
                  {
                    type: 'input',
                    name: 'project__name',
                    label: '项目名称',
                    disabled: true,
                    allowClear: true,
                    inputType: 'text',
                    defaultValue: '',
                  },
                  {
                    type: 'input',
                    name: 'total_num',
                    label: '项目次数',
                    disabled: true,
                    allowClear: true,
                    inputType: 'number',
                    defaultValue: '',
                    placeholder: '请填写项目次数',
                  },
                  // {
                  //   type: 'input',
                  //   name: 'now_num',
                  //   label: '剩余次数',
                  //   disabled: true,
                  //   allowClear: true,
                  //   inputType: 'number',
                  //   defaultValue: '',
                  //   placeholder: '请填写项目次数',
                  // },
                  {
                    type: 'input',
                    name: 'project_price',
                    label: '项目单价',
                    disabled: true,
                    allowClear: true,
                    inputType: 'number',
                    defaultValue: '',
                  },
                  {
                    type: 'input',
                    name: 'cxzc__name',
                    label: '促销政策',
                    disabled: true,
                    allowClear: true,
                    inputType: 'text',
                    defaultValue: '',
                  },
                  {
                    type: 'input',
                    name: 'cancel_num',
                    label: '撤单次数',
                    disabled: false,
                    allowClear: true,
                    inputType: 'number',
                    defaultValue: '',
                  },
                  {
                    type: 'remoteselect',
                    name: 'shop_id',
                    label: '门店列表',
                    disabled: !!current_shop,
                    placeholder: '请选择门店列表',
                    datasourceType: 'remote',
                    mode: 'default',
                    allowClear: true,
                    modalType: 'mjstore-shop',
                  },
                  {
                    type: 'remoteselect',
                    name: 'staff_id',
                    label: '执行人',
                    disabled: false,
                    placeholder: '请选择执行人',
                    datasourceType: 'remote',
                    mode: 'default',
                    allowClear: true,
                    modalType: 'mjstore-querystaffselectlist',
                  },
                  {
                    type: 'datepicker',
                    name: 'date',
                    label: '撤单日期',
                    disabled: false,
                    allowClear: true,
                    inputType: 'number',
                    defaultValue: '',
                    format: 'YYYY-MM-DD HH:mm',
                    valueFormat: 'YYYY-MM-DD HH:mm',
                    showTime: true,
                    placeholder: '请填写撤单日期',
                  },
                  {
                    type: 'textarea',
                    name: 'reason',
                    label: '撤单原因',
                    disabled: false,
                    allowClear: true,
                    inputType: 'text',
                    maxlength: 300,
                    defaultValue: '',
                    placeholder: '请填写备注',
                  },
                ],
                rules: {
                  cancel_num: [{ required: true, message: '请填写撤单次数' }],
                  shop_id: [{ required: true, message: '请选执行门店' }],
                  staff_id: [{ required: true, message: '请选执行人' }],
                  date: [{ required: true, message: '请选择撤单日期' }],
                  reason: [{ required: true, message: '请选择撤单原因' }],
                },
                model: {
                  org_id: current_org?.id,
                  is_active: true,
                  reason: null,
                  cxzc__name: data.cxzc__name,
                  order_record_id: data.id,
                  staff_id: null,
                  shop_id: current_shop?.id,
                  cancel_num: data.now_num,
                  project_price: data.project_price,
                  now_num: data.now_num,
                  total_num: data.total_num,
                  project__name: data.project__name,
                  customer__name: data.customer__name,
                },
                watch: {},
              },
              options: {},
              ok: (data: any) => {
                if (Number(data.cancel_num) > Number(data.now_num)) {
                  notification.error({
                    message: '输入错误',
                    description: '【撤单次数】 > 【项目余次】',
                  });
                  return false;
                }
                return new Promise(resolve => {
                  editModal.loading = true;
                  delete_order_record({
                    ...data,
                    org_id: current_org?.id,
                  })
                    .then(function () {
                      message.success('撤单成功');
                      event_obj.emit('refresh');
                      resolve(null);
                      resolve1(null);
                    })
                    .finally(() => {
                      editModal.loading = false;
                    });
                });
              },
            });
            modalBox(editModal);
          }).catch(() => console.log('Oops errors!'));
        },
        onCancel() {},
      });
    },
  },
  {
    name: '换单',
    clazz: 'primary',
    cb: (data: any) => {
      const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
      const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店
      const editModal = reactive({
        visible: true,
        loading: false,
        title: '换单',
        form: {
          settings: {
            labelAlign: 'right',
            layout: 'horizontal',
            col: [4, 9],
            labelCol: {
              span: 8,
            },
            wrapperCol: {
              span: 16,
            },
          },
          fields: [
            {
              type: 'input',
              name: 'customer__name',
              label: '会员名称',
              disabled: true,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
            {
              type: 'input',
              name: 'project__name',
              label: '原单',
              disabled: true,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
            {
              type: 'input',
              name: 'order_num',
              label: '项目次数（换）',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              placeholder: '请填写项目次数（换）',
            },
            {
              type: 'input',
              name: 'project_price',
              label: '项目金额',
              disabled: true,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              placeholder: '请填写项目金额',
            },
            {
              type: 'input',
              name: 'customer__name',
              label: '会员名称',
              disabled: true,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
            {
              type: 'remotemodal',
              name: 'project_id',
              label: '新单',
              disabled: false,
              placeholder: '请选择新单',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-project',
            },
            {
              type: 'input',
              name: 'num',
              label: '项目次数（耗）',
              disabled: true,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
            {
              type: 'input',
              name: 'project_price1',
              label: '项目金额',
              disabled: true,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
            {
              type: 'input',
              name: 'diff_price',
              label: '换单价差',
              disabled: true,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
            {
              type: 'remoteselect',
              name: 'shop_id',
              label: '执行门店',
              disabled: !!current_shop,
              placeholder: '请选择执行门店',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-shop',
            },
            {
              type: 'remoteselect',
              name: 'staff_id',
              label: '执行人',
              disabled: false,
              placeholder: '请选择执行人',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-querystaffselectlist',
            },
            {
              type: 'datepicker',
              name: 'date',
              label: '换单日期',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              format: 'YYYY-MM-DD HH:mm',
              valueFormat: 'YYYY-MM-DD HH:mm',
              showTime: true,
              placeholder: '请填写换单日期',
            },
            {
              type: 'textarea',
              name: 'mark',
              label: '换单原因',
              disabled: false,
              allowClear: true,
              inputType: 'text',
              maxlength: 300,
              defaultValue: '',
              placeholder: '请填写换单原因',
            },
          ],
          rules: {
            project_id: [{ required: true, message: '请选项目名称' }],
            diff_price: [{ required: true, message: '请填写换单差价' }],
            staff_id: [{ required: true, message: '请选择执行人' }],
            shop_id: [{ required: true, message: '请选择执行门店' }],
            order_num: [{ required: true, message: '请填写消耗卡单数' }],
            num: [{ required: true, message: '请填写消耗单数' }],
            date: [{ required: true, message: '请填写耗卡时间' }],
            mark: [{ required: true, message: '请填写换单原因' }],
          },
          model: {
            org_id: current_org?.id,
            order_record_id: data.id,
            staff_id: null,
            num: 1,
            order_num: 1,
            shop_id: current_shop?.id,
            project_price: data.project_price,
            project__name: data.project__name,
            customer__name: data.customer__name,
            customer_id: data.customer_id,
          },
          watch: {
            project_id: (data: any) => {
              if (data['project_id'] > 0) {
                get_project_by_id({
                  org_id: current_org.id,
                  project_id: Number(data.project_id),
                }).then((res: any) => {
                  data['project_price1'] = res.price;
                  data['diff_price'] =
                    Number(data['project_price1']) - Number(data['project_price']);
                });
              }
            },
            order_num: (data1: any) => {
              if (data1['order_num']) {
                data1['project_price'] = Number(data['project_price']) * Number(data1['order_num']);
                if (data1['project_price1']) {
                  data1['diff_price'] =
                    Number(data1['project_price1']) - Number(data1['project_price']);
                }
              } else {
                data1['project_price'] = 0;
                if (data1['project_price1']) {
                  data1['diff_price'] =
                    Number(data1['project_price1']) - Number(data1['project_price']);
                }
              }
            },
          },
        },
        options: {},
        ok: (data: any) => {
          return new Promise(resolve => {
            editModal.loading = true;
            create_order_used_record_by_order(data)
              .then(function () {
                message.success('换单成功');
                event_obj.emit('refresh');
                resolve(null);
              })
              .finally(() => {
                editModal.loading = false;
              });
          });
        },
      });
      modalBox(editModal);
    },
  },
  // {
  //   name: '发送',
  //   clazz: 'primary',
  //   content: (record: any) => {
  //     return record.receipt_confirmed ? '已确认' : '发送';
  //   },
  //   disabled: (record: any) => {
  //     return !!record.receipt_confirmed;
  //   },
  //   cb: (record: any) => {
  //     const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
  //     query_person_to_costom_list({
  //       org_id: current_org?.id,
  //       customer_id: record.customer_id,
  //     }).then((res: any) => {
  //       if (res.data.length == 0 || (res.data.length > 0 && !res.data[0].name)) {
  //         Modal.warning({
  //           title: '提示',
  //           content: '会员尚未绑定，无法发送',
  //         });
  //       } else {
  //         Modal.confirm({
  //           title: '提示',
  //           content: `即将发送下单记录至客户公众号账号，是否继续发送（第${
  //             record.receipt_count + 1
  //           }次发送）`,
  //           onOk() {
  //             send_receipt({
  //               obj_id: record.id,
  //               business_type: 'OrderRecord',
  //               org_id: current_org?.id,
  //             }).then(res => {
  //               message.success('发送成功');
  //               Object.assign(record, res);
  //             });
  //           },
  //           onCancel() {},
  //         });
  //       }
  //     });
  //   },
  // },
  {
    name: '作废',
    //type: 'dropdown',
    clazz: 'danger',
    is_show: (record: any) => {
      return !record.is_delete && record.now_num === record.total_num && !record.set_record_id;
    },
    cb: (record: any) => {
      const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
      if (record.set_record_id) {
        Modal.confirm({
          title: '提示',
          content: `该项目所在套餐中的全部项目将同步作废，确定作废后请重新购买套餐`,
          onOk() {
            direct_delete_set_record({
              set_record_id: record.set_record_id,
              org_id: current_org?.id,
            }).then((res: any) => {
              if (res.show_message) {
                Modal.warning({
                  title: res.show_message,
                });
              } else {
                message.success('作废成功');
                event_obj.emit('refresh');
              }
            });
          },
          onCancel() {},
        });
      } else {
        Modal.confirm({
          title: '提示',
          content: `是否作废此项记录`,
          onOk() {
            direct_delete_order_record({
              org_id: current_org?.id,
              order_record_id: record.id,
            }).then(() => {
              message.success('作废成功');
              event_obj.emit('refresh');
            });
          },
          onCancel() {},
        });
      }
    },
  },
];
export const slotList = defaultSlotList;
export const config = {
  creatCol: [],
  updateCol: [],
};

export const head_btn_list = [
  {
    name: '新建',
    clazz: 'primary',
    icon: 'plus-outlined',
    cb: () => {
      const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
      const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店
      const project_ids: Array<number> = reactive([]);
      const editModal = reactive({
        visible: true,
        loading: false,
        title: '新建',
        form: {
          settings: {
            labelAlign: 'right',
            layout: 'horizontal',
            col: [7, 7],
            labelCol: {
              span: 7,
            },
            wrapperCol: {
              span: 17,
            },
          },
          fields: [
            {
              type: 'remotemodal',
              name: 'customer_id',
              label: '会员姓名',
              disabled: false,
              placeholder: '请选择会员姓名',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-customer',
            },
            {
              type: 'remotemodal',
              name: 'project_id',
              label: '项目名称',
              disabled: false,
              placeholder: '请选择项目名称',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-project',
            },
            {
              type: 'number',
              name: 'total_num',
              label: '项目次数',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              min: 1,
              placeholder: '请填写项目次数',
            },
            {
              type: 'number',
              name: 'total_price',
              label: '项目单价',
              disabled: true,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              placeholder: '请填写项目单价',
            },
            {
              type: 'number',
              name: 'price',
              label: '项目金额',
              disabled: true,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              placeholder: '请填写项目单价',
            },
            {
              type: 'number',
              name: 'czje',
              label: '充值使用金额',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              placeholder: '请填写充值使用金额',
            },
            {
              type: 'number',
              name: 'flje',
              label: '返利使用金额',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              placeholder: '请填写返利使用金额',
            },
            {
              type: 'number',
              name: 'zjfl',
              label: '直接返利',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              placeholder: '请填写直接返利',
            },
            {
              type: 'number',
              name: 'zjje',
              label: '赠券使用金额',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              placeholder: '请填写赠券使用金额',
            },

            {
              type: 'remoteselect',
              name: 'cxzc_id',
              label: '促销政策',
              disabled: false,
              placeholder: '请选择促销政策',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-policy',
            },
            {
              type: 'datepicker',
              name: 'date',
              label: '下单时间',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              format: 'YYYY-MM-DD HH:mm',
              valueFormat: 'YYYY-MM-DD HH:mm',
              showTime: true,
              placeholder: '请填写下单时间',
            },
            {
              type: 'remoteselect',
              name: 'shop_id',
              label: '门店列表',
              disabled: !!current_shop,
              placeholder: '请选择门店列表',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-shop',
            },
            {
              type: 'remoteselect',
              name: 'staff_id',
              label: '执行人',
              disabled: false,
              placeholder: '请选择执行人',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-querystaffselectlist',
            },
            {
              type: 'input',
              name: 'mark',
              label: '备注',
              disabled: false,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
              placeholder: '请填写备注',
            },
          ],
          rules: {
            customer_id: [{ required: true, message: '请选会员姓名' }],
            czje: [{ required: true, message: '请填写充值使用金额' }],
            flje: [{ required: true, message: '请填写返利使用金额' }],
            zjfl: [{ required: true, message: '请填写直接返利' }],
            zjje: [{ required: true, message: '请填写赠券使用金额' }],
            date: [{ required: true, message: '请填写作废日期' }],
            shop_id: [{ required: true, message: '请选执行门店' }],
            staff_id: [{ required: true, message: '请选执行人' }],
            total_num: [{ required: true, message: '请填写项目次数' }],
            cxzc_id: [{ required: true, message: '请选择促销政策' }],
          },
          model: {
            org_id: current_org?.id,
            is_active: true,
            num: 0,
            zjfl: 0,
            zjje: 0,
            date: moment().format('YYYY-MM-DD HH:mm'),
            total_num: 1,
            project_id: project_ids,
            shop_id: current_shop?.id,
          },
          watch: {
            project_id: (data: any) => {
              if (data.project_id > 0) {
                get_project_by_id({
                  org_id: current_org.id,
                  project_id: Number(data.project_id),
                }).then((res: any) => {
                  console.log('res', res);
                  data['total_price'] = res.price;
                  if (Number(data.total_price) >= 0) {
                    data['price'] = Number(data.total_num) * Number(data.total_price);
                  }
                  data['czje'] = calculate_cz_price(data, data.cz_rate);
                  data['flje'] = calculate_fl_price(data);
                });
              }
            },
            total_num: (data: any) => {
              if (Number(data.total_price) >= 0) {
                data['price'] = Number(data.total_num) * Number(data.total_price);
              }
              data['czje'] = calculate_cz_price(data, data.cz_rate);
              data['flje'] = calculate_fl_price(data);
            },
            total_price: (data: any) => {
              if (Number(data.total_price) >= 0) {
                data['price'] = Number(data.total_num) * Number(data.total_price);
              }
            },
            zjfl: (data: any) => {
              data['czje'] = calculate_cz_price(data, data['cz_rate']);
              data['flje'] = calculate_fl_price(data);
            },
            zjje: (data: any) => {
              data['czje'] = calculate_cz_price(data, data['cz_rate']);
              data['flje'] = calculate_fl_price(data);
            },
            customer_id: (data: any) => {
              get_customer_wallet_fl_rate({
                org_id: current_org.id,
                customer_id: Number(data.customer_id),
              }).then((res: any) => {
                data['cz_rate'] = 1 - res.fl_rate;
              });
            },
          },
        },
        options: {},
        ok: (data: any) => {
          const p = new Promise(function (resolve) {
            if (
              Number(data.czje) + Number(data.flje) + Number(data.zjfl) + Number(data.zjje) !=
              Number(data.price)
            ) {
              notification.error({
                message: '金额输入错误',
                description:
                  '下单金额应等于【充值使用金额】+【下单返利金额】+【直接返利金额】+【赠券使用金额】',
              });
              return false;
            }
            editModal.loading = true;
            create_order_record({ ...data, org_id: current_org?.id })
              .then((res: any) => {
                if (res.is_confirm) {
                  Modal.confirm({
                    title: '提示',
                    content: res.message,
                    onOk() {
                      return new Promise(resolve1 => {
                        create_order_record({
                          ...data,
                          org_id: current_org?.id,
                          is_confirm: true,
                        })
                          .then(function () {
                            message.success('创建成功');
                            event_obj.emit('refresh');
                            resolve(null);
                          })
                          .finally(() => {
                            resolve1(null);
                            editModal.loading = false;
                          });
                      });
                    },
                    onCancel() {},
                  });
                } else {
                  message.success('创建成功');
                  event_obj.emit('refresh');
                  resolve(null);
                }
              })
              .finally(() => {
                editModal.loading = false;
              });
          });
          return p;
        },
      });
      modalBox(editModal);
    },
  },
  // {
  //   name: '导出',
  //   clazz: 'primary',
  //   cb: (search_model: any) => {
  //     const current_org = ls.get(STORAGE_CURRENT_ORG_KEY);
  //     const payload: any = {
  //       org_id: current_org?.id,
  //       ...search_model,
  //     };
  //     let params_str = '';
  //     Object.keys(payload).forEach(key => {
  //       if (payload[key] != null && key != 'current' && key != 'pageSize') {
  //         params_str += key + '=' + payload[key] + '&';
  //       }
  //     });
  //     window.open(
  //       '/mjstore/query_order_record_normal_list?export=true&' + params_str + new Date().getTime(),
  //       '_blank',
  //     );
  //     message.success('导出成功');
  //   },
  // },
];
